import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared/shared.module";
import { PublicComponent } from "./oauth/public/public.component";
import { VenueNotFoundComponent } from './venue-not-found/venue-not-found.component';
import { VenueLocatorComponent } from './venue-locator/venue-locator.component';
import { VenueListComponent } from './venue-locator/venue-list/venue-list.component';
import { VenueListingComponent } from './venue-locator/venue-listing/venue-listing.component';

@NgModule({
	declarations: [PublicComponent, VenueNotFoundComponent, VenueLocatorComponent, VenueListComponent, VenueListingComponent],
	imports: [SharedModule],
})
export class PublicModule {}
